import React from 'react';
import { Helmet } from 'react-helmet';
import './MDBSysPrivacyPolicy.css';  
import logo from '../assets/img/logo-mdb.png';

const MDBSysPrivacyPolicy: React.FC = () => {
  return (
    <div className="privacy-policy-container">
      <Helmet>
        <title>Privacy Policy - MDB Sys by Media Djaya Bersama</title>
        <meta name="description" content="Privacy policy for MDB Sys mobile application from Media Djaya Bersama" />
      </Helmet>

      <header className="policy-header">
        <div className="company-logo">
          <img
            src={logo}
            alt="Media Djaya Bersama Logo"
            className="logo-img"
          />
          <h1 className="title">Media Djaya Bersama</h1>
        </div>
        <h2 className="title">Privacy Policy for MDB Sys</h2>
        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
      </header>

      <div className="policy-content">
        <section>
          <p>PT Media Djaya Bersama ("us", "we", or "our") operates the MDB Sys mobile application (the "Service").</p>
          <p>This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.</p>
        </section>

        <section>
          <h3>Information Collection and Use</h3>
          <p>We collect several different types of information for various purposes to provide and improve our Service to you.</p>
        </section>

        <section>
          <h4>Types of Data Collected</h4>
          <h5>Personal Data</h5>
          <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:</p>
          <ul>
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Company information</li>
            <li>Usage data</li>
          </ul>
        </section>

        <section>
          <h4>Usage Data</h4>
          <p>When you access the Service, we may collect certain information automatically, including:</p>
          <ul>
            <li>Type of mobile device</li>
            <li>Device unique ID</li>
            <li>IP address</li>
            <li>Mobile operating system</li>
            <li>Mobile Internet browser type</li>
            <li>Diagnostic data</li>
          </ul>
        </section>

        <section>
          <h3>Use of Data</h3>
          <p>MDB Sys uses the collected data for various purposes:</p>
          <ul>
            <li>To provide and maintain our Service</li>
            <li>To notify you about changes to our Service</li>
            <li>To allow you to participate in interactive features</li>
            <li>To provide customer support</li>
            <li>To gather analysis to improve our Service</li>
            <li>To monitor Service usage</li>
            <li>To detect and prevent technical issues</li>
          </ul>
        </section>

        <section>
          <h3>Data Security</h3>
          <p>The security of your data is important to us. We implement appropriate technical and organizational measures to protect your personal data. However, no Internet transmission or electronic storage is 100% secure.</p>
        </section>

        <section>
          <h3>Service Providers</h3>
          <p>We may employ third-party companies to facilitate our Service, provide the Service on our behalf, or assist us in analyzing how our Service is used.</p>
          <p>These third parties have access to your Personal Data only to perform these tasks and are obligated not to disclose or use it for other purposes.</p>
        </section>

        <section>
          <h3>Changes to This Policy</h3>
          <p>We may update our Privacy Policy periodically. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "last updated" date.</p>
        </section>

        <section>
          <h3>Contact Us</h3>
          <p>If you have any questions about this Privacy Policy, please contact us:</p>
          <ul className="contact-info">
            <li>By email: info@mdbsys.com</li>
            <li>By visiting our website: www.mdbsys.com</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default MDBSysPrivacyPolicy;
